"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragAndDropComponent = void 0;
const core_1 = require("@dnd-kit/core");
const modifiers_1 = require("@dnd-kit/modifiers");
const sortable_1 = require("@dnd-kit/sortable");
const React = __importStar(require("react"));
const react_1 = require("react");
const utils_1 = require("./utils");
const DragAndDropComponent = (props) => {
    const { setItemIds, columnAmount, itemIds, children, onItemDrop } = props;
    const [activeId, setActiveId] = react_1.useState(null);
    const activeIndex = activeId ? itemIds.indexOf(activeId) : -1;
    const sensors = core_1.useSensors(core_1.useSensor(core_1.PointerSensor), core_1.useSensor(core_1.KeyboardSensor, { coordinateGetter: sortable_1.sortableKeyboardCoordinates }));
    const rowAmount = Math.ceil(itemIds.length / columnAmount);
    const measuring = {
        droppable: {
            strategy: core_1.MeasuringStrategy.Always,
        },
    };
    const onDragStart = ({ active }) => {
        if (typeof active.id === 'string') {
            setActiveId(active.id);
        }
    };
    const onDragEnd = ({ over }) => {
        if (over && typeof over.id === 'string') {
            const overIndex = itemIds.indexOf(over.id);
            if (activeIndex !== overIndex) {
                const newIndex = overIndex;
                if (onItemDrop && activeId) {
                    onItemDrop(activeId, newIndex);
                }
                setItemIds((old) => sortable_1.arrayMove(old, activeIndex, newIndex));
            }
        }
        setActiveId(null);
    };
    return (React.createElement(core_1.DndContext, { sensors: sensors, collisionDetection: core_1.closestCenter, onDragStart: onDragStart, onDragEnd: onDragEnd, modifiers: [modifiers_1.restrictToParentElement], measuring: measuring },
        React.createElement(sortable_1.SortableContext, { items: itemIds },
            React.createElement("ul", { className: "dnd-grid-container", style: {
                    gridTemplateColumns: `repeat(${columnAmount}, 1fr`,
                    gridTemplateRows: `repeat(${rowAmount}, 1fr`,
                } }, children)),
        React.createElement(utils_1.DragAndDropCloneContext.Provider, { value: { clone: true } },
            React.createElement(core_1.DragOverlay, { modifiers: [modifiers_1.restrictToParentElement] }, activeId ? children[activeIndex] : null))));
};
exports.DragAndDropComponent = DragAndDropComponent;
//# sourceMappingURL=DragAndDropComponent.js.map